export default "__VITE_ASSET__fcb6ea84__"